export const customTooltip = {
    backgroundColor: '#E7E7FF',
    bodyColor: '#000',
    titleColor: '#000',
    footerColor: '#E7E7FF',
    padding: 8
}

export const CHART_COLORS = {
    BLUE : "#5F67E0",
    SELECTED_BLUE : "#3C43A6",
    YELLOW : "#FFD747",
    SELECTED_YELLOW : "#FFC700",
    RED : "#961B01",
    SELECTED_RED : "#961B01",
    GREEN: '#1B5E20',
    SELECTED_GREEN: '#1B5E20',
    ORANGE: '#FFA500',
    SELECTED_ORANGE: '#FFA500',
    VIOLET: '#8F00FF',
    SELECTED_VIOLET: '#8F00FF',
}